import React from 'react';
import { useTranslate } from 'react-translate';
import { Button } from 'reactstrap';
const BtnNew = ({ mobile, setShowForm, setReply, setResend, handleNewMessage, isDisaffected }) => {
  const t = useTranslate('messages');
  return (
    <Button
      className="btn-new"
      disabled={isDisaffected}
      color="info"
      size="sm"
      name="new-message-btn"
      onClick={(e) => {
        handleNewMessage();
        setShowForm(true);
        setReply(false);
        setResend(false);
      }}
    >
      {!mobile && t('btn-new')} <i className="fas fa-plus"></i>
    </Button>
  );
};

export default BtnNew;
